import { Outlet } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import StructuredData from './StructuredData';
import PageVisitTracker from './PageVisitTracker';
import SEO from './SEO';

const MainLayout = () => {
  return (
    <>
      <SEO />
      <StructuredData />
      <PageVisitTracker />
      <div className="flex flex-col min-h-screen">
        <Navigation />
        <div className="flex-1">
          <Outlet />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default MainLayout;
